'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageUrlStoreService
 * @description Retrieves information from the query string (not set), based
 * on {@link vTvPackageServices.TvPackageCartStoreInterface TvPackageCartStoreInterface}
 */

angular.module('v-tv-package-services').factory('TvPackageUrlStoreService', function TvPackageUrlStoreService(TvPackageCartStoreInterface, $location, LZString, $q) {

    var store = new TvPackageCartStoreInterface('Url');

    store.canWrite = true;
    store.getItem = function (key) {
        var params = $location.search();

        if (params[key]) {
            try {
                return $q.when(angular.fromJson(LZString.decompressFromBase64(params[key])) || null);
            } catch (e) {
                return $q.when(null);
            }
        }

        return $q.when(null);
    };

    store.setItem = function (key, value) {
        if (value === null) {
            return $q.when($location.search(key, null).replace());
        }
        return $q.when($location.search(key, LZString.compressToBase64(angular.toJson(value))).replace());
    };

    return store;
});